/**
 * SYNC REQUIREMENT: This pluginStyles object structure must be kept in sync with the Monaco editor type definitions
 * in apps/website/src/@fuse/pages/plugins/types/pluginEditorTypes.ts (PluginAPI.Theme interface)
 *
 * When modifying this structure:
 * 1. Update the corresponding type string in pluginEditorTypes.ts
 * 2. Ensure property names and nested structure match exactly
 * 3. Update color values and spacing values in the type definitions
 */
// Define common plugin styles
export const pluginStyles = {
  // Colors
  colors: {
    primary: "#3b82f6", // blue-500
    secondary: "#6b7280", // gray-500
    success: "#10b981", // green-500
    danger: "#ef4444", // red-500
    warning: "#f59e0b", // amber-500
    info: "#3b82f6", // blue-500
    light: "#f3f4f6", // gray-100
    dark: "#1f2937", // gray-800
  },

  // Text styles
  text: {
    title: "text-2xl font-bold text-gray-900 mb-4",
    subtitle: "text-xl font-semibold text-gray-800 mb-3",
    body: "text-base text-gray-700",
    small: "text-sm text-gray-500",
    link: "text-blue-500 hover:text-blue-700 hover:underline cursor-pointer",
  },

  // Layout
  layout: {
    container: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
    section: "py-6",
    card: "bg-white shadow rounded-lg p-6",
    divider: "border-t border-gray-200 my-6",
    flexRow: "flex flex-row items-center",
    flexCol: "flex flex-col",
    grid: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6",
  },

  // Form components
  form: {
    label: "block text-sm font-medium text-gray-700 mb-1",
    input:
      "w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500",
    select:
      "w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500",
    checkbox: "rounded border-gray-300 text-blue-600 focus:ring-blue-500",
    error: "mt-1 text-sm text-red-600",
    group: "mb-4",
  },

  // Utility classes
  utils: {
    p: "p-4",
    px: "px-4",
    py: "py-4",
    m: "m-4",
    mx: "mx-4",
    my: "my-4",
    rounded: "rounded-lg",
    shadow: "shadow-md",
    center: "flex items-center justify-center",
    between: "flex items-center justify-between",
  },
}
